module.exports = __webpack_public_path__ + "static/img/absolutvision-WYd_PkCa1BY-unsplash_thumb.6470f20.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ads/standard_bg/absolutvision-WYd_PkCa1BY-unsplash_thumb.png
// module id = wkxs
// module chunks = 4